<template>
  <div class="function-component">
    <div class="row">
      <div class="row__button">
        <template v-if="_isDisabled">
          <img class="disabled-button" :src="_disabledButtonSrc" alt="disabled-button" />
        </template>
        <template v-else>
          <img
            :key="_playButtonSrc"
            class="play-button"
            :src="_playButtonSrc"
            @click="onPlayButtonClick"
            @mouseover="onPlayButtonChangeImg"
            @mouseleave="onPlayButtonReturnImg"
            alt="play-button"
          />
        </template>
      </div>
      <div class="row__input">
        <select v-model="$data.selectedType" :style="{ backgroundImage: `url('${_selectArrowSrc}')` }">
          <template v-for="(option, index) in _options">
            <option :key="`option-${index}`" :value="option.value">
              {{ option.name }}
            </option>
          </template>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="row__button">
        <template v-if="_isDisabled">
          <img class="disabled-button" :src="_disabledButtonSrc" alt="disabled-button" />
        </template>
        <template v-else>
          <img
            class="reset-button"
            :src="_resetButtonSrc"
            @click="onResetButtonClick"
            @mouseover="onResetButtonChangeImg"
            @mouseleave="onResetButtonReturnImg"
            alt="reset-button"
          />
        </template>
      </div>
      <div class="row__input">
        <p>birth rate</p>

        <label for="birthrateRange">
          <div class="range-area">
            <input
              id="birthrateRange"
              class="range"
              type="range"
              v-model="$data.dataLifeDeathRatios[`${$data.selectedType}`].birthRate"
              min="0"
              max="100"
              step="0.001"
            />
            <div class="result">
              {{ $data.dataLifeDeathRatios[`${$data.selectedType}`].birthRate }}
            </div>
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="row__button">
        <template v-if="_isDisabled">
          <img class="disabled-button" :src="_disabledButtonReverseSrc" alt="disabled-button" />
        </template>
        <template v-else>
          <img
            class="restore-button"
            :src="_restoreButtonSrc"
            @click="onRestoreButtonClick"
            @mouseover="onRestoreButtonChangeImg"
            @mouseleave="onRestoreButtonReturnImg"
            alt="restore-button"
          />
        </template>
      </div>
      <div class="row__input">
        <p>death rate</p>
        <label for="deathrateRange">
          <div class="range-area">
            <input
              id="deathrateRange"
              class="range"
              type="range"
              v-model="$data.dataLifeDeathRatios[`${$data.selectedType}`].deathRate"
              min="0"
              max="100"
              step="0.001"
            />
            <div class="result">
              {{ $data.dataLifeDeathRatios[`${$data.selectedType}`].deathRate }}
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANS from '@/constants/index.js';
import BUTTON_SVGS from '../assets/images/buttons/index.js';
import SELECT_ARROW from '../assets/images/select-arrow.svg';

export default {
  props: {
    lifeDeathRatios: Object,
    isSoundLoadComplete: Boolean,
  },
  data() {
    return {
      isPause: true,
      selectedType: 'agent_1',
      dataLifeDeathRatios: this.$props.lifeDeathRatios,
    };
  },
  watch: {
    // restoreで親の値が変わったら子も変える
    lifeDeathRatios(value) {
      this.$data.dataLifeDeathRatios = value;
    },
  },
  computed: {
    _isDisabled() {
      return !this.$props.isSoundLoadComplete;
    },
    _options() {
      return CONSTANS.AGENT_TYPES;
    },
    _disabledButtonSrc() {
      return BUTTON_SVGS.DISABLED_BUTTON;
    },
    _disabledButtonReverseSrc() {
      return BUTTON_SVGS.DISABLED_BUTTON_REVERSE;
    },
    _playButtonSrc() {
      return this.$data.isPause ? BUTTON_SVGS.PLAY_BUTTON : BUTTON_SVGS.PAUSE_BUTTON;
    },
    _resetButtonSrc() {
      return BUTTON_SVGS.RESET_BUTTON;
    },
    _restoreButtonSrc() {
      return BUTTON_SVGS.RESTORE_BUTTON;
    },
    _selectArrowSrc() {
      return SELECT_ARROW;
    },
  },
  methods: {
    onPlayButtonClick() {
      this.$data.isPause = !this.$data.isPause;
      this.$emit('runPause', this.$data.isPause);
    },
    onPlayButtonChangeImg(e) {
      const hoverSrc = this.$data.isPause ? BUTTON_SVGS.PLAY_BUTTON_HOVER : BUTTON_SVGS.PAUSE_BUTTON_HOVER;
      e.target.setAttribute('src', hoverSrc);
    },
    onPlayButtonReturnImg(e) {
      const src = this.$data.isPause ? BUTTON_SVGS.PLAY_BUTTON : BUTTON_SVGS.PAUSE_BUTTON;
      e.target.setAttribute('src', src);
    },
    onResetButtonClick() {
      this.$emit('runReset');
    },
    onResetButtonChangeImg(e) {
      const src = BUTTON_SVGS.RESET_BUTTON_HOVER;
      e.target.setAttribute('src', src);
    },
    onResetButtonReturnImg(e) {
      const src = BUTTON_SVGS.RESET_BUTTON;
      e.target.setAttribute('src', src);
    },
    onRestoreButtonClick() {
      this.$emit('runRestore');
    },
    onRestoreButtonChangeImg(e) {
      const src = BUTTON_SVGS.RESTORE_BUTTON_HOVER;
      e.target.setAttribute('src', src);
    },
    onRestoreButtonReturnImg(e) {
      const src = BUTTON_SVGS.RESTORE_BUTTON;
      e.target.setAttribute('src', src);
    },
  },
};
</script>

<style lang="scss" scoped>
.function-component {
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 267px;
  margin-bottom: -11px;
  z-index: 2;
}

.row {
  display: flex;
  margin: 12px 0;
  height: 24px;
  width: 100%;

  &__button {
    flex: 0 0 24px;
  }

  &__input {
    margin-left: 16px;
    flex: 1 1 0;

    p {
      font-size: 10px;
      letter-spacing: 1px;
      color: #070751;
    }
  }
}

@keyframes button-hover {
  // 0% {transform: scale(1.0, 1.0)}
  // 75% {transform: scale(1.3, 1.3)}
  100% {
    transform: scale(1.1, 1.1);
  }
}

@keyframes button-active {
  // 0% {transform: scale(1.0, 1.0)}
  // 75% {transform: scale(1.3, 1.3)}
  100% {
    transform: scale(1.1, 1.1);
  }
}

@mixin button-base {
  cursor: pointer;

  &:hover {
    animation: button-hover 0.1s linear;
    transform: scale(1.1, 1.1);
  }

  &:active {
    transition: all 0.1s linear;
    transform: scale(1.3, 1.3);
  }
}

.disabled-button {
  cursor: not-allowed;
}

.play-button {
  @include button-base;
}

.reset-button {
  @include button-base;
}

.restore-button {
  @include button-base;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  border: none;
  background-repeat: no-repeat;
  background-size: 8px 9px;
  background-position: right 10px center;
  background-color: #fff;

  height: 24px;
  width: 71%;
  border: 1px solid rgba(7, 7, 81, 0.6);
  color: #070751;
  border-radius: 2px;
  font-size: 10px;
  letter-spacing: 1px;

  cursor: pointer;
  transition: all 0.1s cubic-bezier(0.32, 0.625, 0.58, 1);

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    border: 1px solid rgba(7, 7, 81, 1);
  }
}

.range-area {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 4px;
}

.range {
  border-radius: 5px;
  background: #070751;
  outline: none;
  appearance: none;
  height: 1px;
  flex: 1 1 0;
  cursor: pointer;

  // Range Handle
  &::-webkit-slider-thumb {
    appearance: none;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #070751;
    cursor: pointer;
    transition: background 0.15s ease-in-out;

    &:hover {
      background: #070751;
    }
  }

  &:active::-webkit-slider-thumb {
    background: #070751;
  }

  &::-moz-range-thumb {
    width: 8px;
    height: 8px;
    border: 0;
    border-radius: 50%;
    background: #070751;
    cursor: pointer;
    transition: background 0.15s ease-in-out;

    &:hover {
      background: #070751;
    }
  }
}

.result {
  flex: 0 0 30px;
  margin-left: 6px;
  color: #070751;
}
</style>
